<script>
import { defineComponent } from '@vue/composition-api'
import LogoDarkDe from '../assets/logo_dark_de.svg'
import LogoWhiteDe from '../assets/logo_white_de.svg'
import LogoDarkFr from '../assets/logo_dark_fr.svg'
import LogoWhiteFr from '../assets/logo_white_fr.svg'
import LogoDarkEn from '../assets/logo_dark_en.svg'
import LogoWhiteEn from '../assets/logo_white_en.svg'

export default defineComponent({
  components: {
    LogoDarkDe,
    LogoWhiteDe,
    LogoDarkFr,
    LogoWhiteFr,
    LogoDarkEn,
    LogoWhiteEn,
  },
  props: {
    variant: {
      type: String,
      default: 'dark',
    },
  },
  render(h) {
    const { lang } = this.$store.state

    let LogoDark = null
    let LogoWhite = null

    switch (lang) {
      case 'fr':
        LogoDark = LogoDarkFr
        LogoWhite = LogoWhiteFr
        break
      case 'en':
        LogoDark = LogoDarkEn
        LogoWhite = LogoWhiteEn
        break
      default:
        LogoDark = LogoDarkDe
        LogoWhite = LogoWhiteDe
    }

    return h(this.variant === 'dark' ? LogoDark : LogoWhite)
  },
})
</script>
